import React from 'react';
import OfflineHome from "./Components/OfflineHome/OfflineHome";
import Home from "./Components/Home/Home"
import { connect } from 'react-redux'
import isElectron from "is-electron";

const HomeWrapper = ( props ) => {
    const { isNetworkAvailable/*, isServerReachable*/ } = props;
    const canConnect = isNetworkAvailable //&& isServerReachable;

    if ( isElectron() ) {
        return (
            <React.Fragment>
                { canConnect ? <Home/> : <OfflineHome/> }
            </React.Fragment>
        );
    } else {
        return (
            <div>
                <Home/>
            </div>
        )
    }
}

const mapStateToProps = ( state ) => ({
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    isServerReachable: state.sensors.isServerReachable
})
export default connect( mapStateToProps )( HomeWrapper );